import UAParser from 'ua-parser-js'

/**
 *
 * @param {fmt} fmt
 * @param {date} date
 * @returns
 */
export function dateFtt(fmt,date, language = 'ja')
{
  if(!date) {
    return '';
  }
  if(typeof date == 'string') {
    date = new Date(date)
  }
  if (fmt == 'auto') {
    if(language == 'ja') {
      fmt = 'yyyy年MM月dd日'
    }else {
      fmt = 'yyyy/MM/dd'
    }
  }else if (fmt == 'auto_time') {
    if(language == 'ja') {
      fmt = 'yyyy年MM月dd日 hh:mm'
    }else {
      fmt = 'yyyy/MM/dd hh:mm'
    }
  } else if (fmt == 'auto_times'){
    if(language == 'ja') {
      fmt = 'yyyy年MM月dd日 hh:mm:ss'
    }else {
      fmt = 'yyyy/MM/dd hh:mm:ss'
    }
  } else if (fmt == 'auto_date') {
    if(language == 'ja') {
      fmt = 'yyyy年M月d日'
    }else {
      fmt = 'yyyy/MM/dd'
    }
  }
  var o = {
    "M+" : date.getMonth()+1,
    "d+" : date.getDate(),
    "h+" : date.getHours(),
    "m+" : date.getMinutes(),
    "s+" : date.getSeconds(),
    "q+" : Math.floor((date.getMonth()+3)/3),
    "S"  : date.getMilliseconds()
  };
  if(/(y+)/.test(fmt)) {
    fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
  }
  const regexMap = {
    'M+' : /(M+)/,
    'd+' : /(d+)/,
    'h+' : /(h+)/,
    'm+' : /(m+)/,
    's+' : /(s+)/,
    'q+' : /(q+)/,
    'S+' : /(S)/
  };
  for(var k in o) {
    if (regexMap.hasOwnProperty(k) && regexMap[k].test(fmt)) {
       fmt = fmt.replace(regexMap[k], (match) => {
         return (match.length === 1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length));
       });
    }
  }
  return fmt;
}

export function getWinLanguage(){
  // let = locale = 'en'
  let browserLang = navigator.language ? navigator.language : navigator.browserLanguage;
  let defaultBrowserLang = "ja";
  if (browserLang.toLowerCase() == "en" || browserLang.toLowerCase() == "en_us") {
    defaultBrowserLang = "en";
  }
  return defaultBrowserLang;
}

export function yyyymmddToDate(fmt,date){
  if( date ) {
    const y = date.substring(0,4)
    const m = date.substring(4,6)
    const d = date.substring(6,8)
    return y + fmt + m + fmt + d
  }
  return '';

}

export function getFileName(filepath) {
  if (filepath != "") {
      var names = filepath.split("\\");
      return names[names.length - 1];
  }
}

export function addViews(list, router) {
  const views = require.context('@/views/', true, /\.vue$/)
  list.forEach(d => {
      if(d.viewPath){
          d.component = () => Promise.resolve(views(d.viewPath));
      } else {
          d.redirect = "/session_timeout";
      }
      router.addRoute("usr_top", d);
  });
}
const timeout = 1000*60*60*2
export function getStoreCondition(key, cacheKey, store) {
  if(!cacheKey || !key || !store){
    return;
  }
  let condition = store.getters[key]
  if(condition){
    condition = condition[cacheKey]
    if(condition) {
      if(condition.pathname == location.pathname && new Date().getTime() - condition.time < timeout) {
        return condition.data;
      }else {
        store.commit(key, null)
      }
    }
  }

  return null
}
/**
 *
 * @param {store key} key
 * @param {*} data
 * @param {*} store
 */
export function putStoreCondition(key, cacheKey, data, store) {
  if(!cacheKey || !key || !store){
    return;
  }
  let condition = store.getters[key]
  if(!condition) {
    condition = {}
  }

  if(condition != null ){
    if(data == null) {
      delete condition[cacheKey]
    }else{
      condition[cacheKey] = {data:data, pathname:location.pathname, time:new Date().getTime()}
    }

  }
  store.commit(key, condition)
}

export function getBrowserMess() {
  const browserMess = {
    enOs: '',
    enBrowser: '',
    enJs: '',
    enCookie: '',
    enFlash: '',
    enActiveX: '',
  }

  function OS() {
    var uaParser = new UAParser();
    var os = uaParser.getOS().name;
    var version = uaParser.getOS().version;

    return os === 'Mac OS' ? os : os + " " + version;
  }

  function isIE() {
    var ua = navigator.userAgent;
    var isIeFlg = false;

    if (/MSIE|Trident/.test(ua)) {
        return isIeFlg = true;
    }

    return isIeFlg;
  }

  function base_browser() {
    var ua = window.navigator.userAgent.toLowerCase();
    var ver = window.navigator.appVersion.toLowerCase();
    var name = 'unknown';

    if (ua.indexOf("msie") != -1){
        if (ver.indexOf("msie 6.") != -1){
            name = '6';
        }else if (ver.indexOf("msie 7.") != -1){
            name = '7 (ブラウザモード)';
        }else if (ver.indexOf("msie 8.") != -1){
            name = '8 (ブラウザモード)';
        }else if (ver.indexOf("msie 9.") != -1){
            name = '9 (ブラウザモード)';
        }else if (ver.indexOf("msie 10.") != -1){
            name = '10 (ブラウザモード)';
        }else{
            name = 'Internet Explorer';
        }
      }else if(ua.indexOf('trident/7') != -1){
          name = '11 (ブラウザモード)';
      }else if(ua.indexOf('edge') != -1){
          name = 'Legacy版 Edge';
      }else if (ua.indexOf('chrome') != -1 && ua.indexOf('edg') != -1) {
        name = 'Chromium版 Edge';
      }else if (ua.indexOf('chrome') != -1){
          name = 'Google Chrome';
      }else if (ua.indexOf('safari') != -1){
          name = 'Safari';
      }else if (ua.indexOf('opera') != -1){
          name = 'Opera';
      }else if (ua.indexOf('firefox') != -1){
          name = 'Mozilla Firefox';
      }
      return name;
  }

  browserMess.enOs = OS();
  if ("ActiveXObject" in window) {
    browserMess.enBrowser = "Internet Explorer\n" + document_brower() + "\n" + base_browser()
  } else {
    browserMess.enBrowser =base_browser();
  }

  browserMess.enJs = "有効です。";

  document.cookie = "jmottoCookie";
  if (document.cookie != "") {
    browserMess.enCookie = "有効です。";
  } else {
    browserMess.enCookie = "無効です。";
  }

  browserMess.enFlash = "無効です。";

  if (isIE()) {
      if (window.ActiveXObject || "ActiveXObject" in window) {
        try {
          browserMess.enActiveX = "有効です。"
        } catch (e) {
          browserMess.enActiveX = "無効です。"
        }
      } else {
        browserMess.enActiveX =  "無効です。"
      }
  } else {
    browserMess.enActiveX = "－";
  }

  return browserMess
}

export function HalfToFull(txtstring) {
  var tmp = "";
  for(var i = 0; i < txtstring.length; i++) {
    if(txtstring.charCodeAt(i) == 32){
       tmp = tmp + String.fromCharCode(12288);
    } else if (txtstring.charCodeAt(i) < 127 && txtstring.charCodeAt(i) != 10) {
        tmp = tmp + String.fromCharCode(txtstring.charCodeAt(i) + 65248);
    } else {
      tmp = tmp + String.fromCharCode(txtstring.charCodeAt(i));
    }
  }
  return tmp;
}

export function convert_string_to_hex(s) {
	var byte_arr = [];
	for (var i = 0; i < s.length; i++) {
		var value = s.charCodeAt(i);
		byte_arr.push(value & 255);
		byte_arr.push((value >> 8) & 255);
	}
	return convert_to_formated_hex(byte_arr);
}

function convert_to_formated_hex(byte_arr) {
	var hex_str = "", i, len, tmp_hex;

	if (!is_array(byte_arr)) {
		return false;
	}

	len = byte_arr.length;

	for (i = 0; i < len; ++i) {
		if (byte_arr[i] < 0) {
			byte_arr[i] = byte_arr[i] + 256;
		}
		if (byte_arr[i] === undefined) {
			byte_arr[i] = 0;
		}
		tmp_hex = byte_arr[i].toString(16);

		// Add leading zero.
		if (tmp_hex.length == 1)
			tmp_hex = "0" + tmp_hex;

		hex_str += tmp_hex;
	}

	return hex_str.trim();
}

function is_array(input) {
	return typeof (input) === "object" && (input instanceof Array);
}
